import { render } from "./SortingMobile.vue?vue&type=template&id=ee9048b4&scoped=true"
import script from "./SortingMobile.vue?vue&type=script&lang=js"
export * from "./SortingMobile.vue?vue&type=script&lang=js"

import "./SortingMobile.vue?vue&type=style&index=0&id=ee9048b4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee9048b4"]])

export default __exports__